import { TFunction } from 'react-i18next';
import { object, string } from 'yup';

/** Invite-scanner form validation — cloned from the dark AddScannerModal schema (zone-neutral). */
export const addScannerSchema = (t: TFunction<'translation', undefined>) =>
	object().shape({
		full_name: string()
			.required(t('gates-invite-name-required', 'Full name is required'))
			.min(2, t('gates-invite-name-min', 'Full name must be at least 2 characters')),
		email: string()
			.required(t('gates-invite-email-required', 'Email is required'))
			.email(t('gates-invite-email-invalid', 'Please enter a valid email')),
	});
